import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";
import { standardInputStyles, standardLabelStyles } from "../general.styled";

export const DatePickerContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 250px;
  margin-bottom: 16px;
  margin-right: 10px;
`;

export const DatePickerLabel = styled.label<{
  required?: boolean;
  hasValue?: boolean;
  isFocused?: boolean;
  disabled?: boolean;
}>`
  ${standardLabelStyles}
`;

export const DatePickerInput = styled.div<{
  fontSize?: FontSize;
  hasError?: boolean;
  hasValue?: boolean;
  isOpen?: boolean;
  disabled?: boolean;
}>`
  ${standardInputStyles}
`;

export const CalendarIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  cursor: pointer;
  color: #6b7280;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const CalendarPopup = styled.div<{ isOpen?: boolean }>`
  position: absolute;
  top: -5px;
  left: 260px;
  background: ${Color.White};
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin: 4px 0 0 0;
  padding: 16px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  min-width: 280px;
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const MonthYear = styled.div`
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-size: ${FontSize.Standard};
  font-weight: 500;
  color: ${Color.InputTextColor};
`;

export const NavButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const DayHeader = styled.div`
  text-align: center;
  padding: 8px 4px;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-size: ${FontSize.Small};
  font-weight: 500;
  color: #6b7280;
`;

export const DayCell = styled.button<{
  isToday?: boolean;
  isSelected?: boolean;
  isOtherMonth?: boolean;
}>`
  background: none;
  border: none;
  padding: 8px 4px;
  text-align: center;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-size: ${FontSize.Standard};
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-height: 32px;

  color: ${(props) => {
    if (props.isOtherMonth) return "#d1d5db";
    if (props.isSelected) return Color.White;
    return "#374151";
  }};

  background-color: ${(props) => {
    if (props.isSelected) return "#3b82f6";
    if (props.isToday) return "#f3f4f6";
    return "transparent";
  }};

  &:hover {
    background-color: ${(props) => (props.isSelected ? "#2563eb" : "#f3f4f6")};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SelectedDate = styled.span`
  color: ${Color.InputTextColor};
  font-weight: 400;
  font-size: ${FontSize.Standard};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
`;